<script setup lang="ts">
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useRouter } from "vue-router";
import BaseIcon from "~/components/BaseIcon.vue";
import { useAuthStore } from "~/stores/auth";
const { user } = storeToRefs(useAuthStore());
const isOpenMenu = ref(false);
const router = useRouter();
function handleTryClick() {
  if (user.value?.id) {
    router.push("/try");
  } else {
    router.push("/auth/sign-up");
  }
}

function handleLogout() {
  localStorage.removeItem("access_token");
  user.value = null;
  router.push("/");
}
</script>
<template>
  <header
    class="z-[1] absolute top-0 left-0 right-0 border border-t-transparent border-x-transparent border-b-[#597EFF]"
    :class="$route.path == '/' ? 'white' : 'black'"
  >
    <div class="container">
      <div class="flex justify-between py-4 items-center">
        <RouterLink to="/" class="flex gap-2 items-center">
          <img
            src="@/assets/images/landing/KPI-logo.svg"
            alt="KPI Simplex logo"
          />
          <span class="logo">
            Simplex KPI <br />
            system
          </span>
        </RouterLink>
        <nav class="max-lg:hidden">
          <ul class="flex gap-[12px] xl:gap-[30px] links-list">
            <li class="">
              <a href="#">Afzalliklari</a>
            </li>
            <li class="">
              <a href="#">KPI nima?</a>
            </li>
            <li class="">
              <a href="#">Bog‘lanish</a>
            </li>
            <li class="">
              <a href="#">F.A.Q</a>
            </li>
          </ul>
        </nav>
        <div class="flex gap-3 xl:gap-6">
          <button
            v-if="!user?.id"
            @click="$router.push('/auth/sign-up')"
            class="max-sm:hidden cursor-pointer demo-button"
          >
            Ro'yxatdan o'tish
          </button>
          <button
            v-if="!user?.tenant?.id"
            @click="handleTryClick"
            class="max-sm:hidden cursor-pointer use-button"
          >
            Foydalanish
          </button>
          <!-- <button @click="$router.push('/profile')" v-if="user?.id" class="flex tw-items-center gap-2 lg:gap-3 tw-text-sm  tw-font-medium tw-leading-[150%] user-avatar">
            <span>
              {{ user?.first_name + ' ' + user?.last_name || 'Foydalanuvchi' }}
            </span>
            <BaseIcon
              class="hidden lg:block"
              name="LandingUserAvatar"
            />
          </button> -->
          <el-dropdown  trigger="click">
            <button
                v-if="user?.id"
                class="flex tw-items-center gap-2 lg:gap-3 tw-text-sm tw-font-medium tw-leading-[150%] user-avatar">
              <!-- <div
              > -->
                <span>
                  {{
                    user?.first_name  || "Foydalanuvchi"
                  }}
                </span>
                <BaseIcon class="hidden lg:block" name="LandingUserAvatar" />
              <!-- </div> -->
            </button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="$router.push('/profile')">Shaxsiy kabinet</el-dropdown-item>
                <el-dropdown-item @click="handleLogout()">Hisobdan chiqish</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <img
            width="24px"
            class="lg:hidden"
            @click="isOpenMenu = true"
            src="@/assets/images/landing/menu-icon.svg"
            alt="Menu icon"
          />
        </div>
      </div>
    </div>
    <div
      @click="isOpenMenu = false"
      :class="{
        'opacity-[0] z-[-1]': !isOpenMenu,
        'opacity-[0.5] z-[5] inset-0': isOpenMenu,
      }"
      class="transition-all duration-300 ease-linear bg-[#000] fixed top-0 left-0"
    ></div>
    <div
      :class="{ 'mobile-menu': !isOpenMenu, 'mobile-menu-open': isOpenMenu }"
      class="transition-all duration-300 ease-linear fixed z-[10] left-0 top-0 bg-[#fff] py-[40px] px-[24px] inset-0 max-w-[300px]"
    >
      <div class="flex flex-col justify-between h-full">
        <div>
          <a href="">
            <div class="flex gap-2 items-center">
              <img
                src="@/assets/images/landing/KPI-logo.svg"
                alt="KPI Simplex logo"
              />
              <span class="mobile-logo_text">
                Simplex KPI <br />
                system
              </span>
            </div>
          </a>
          <button
            @click="isOpenMenu = false"
            class="absolute top-[16px] right-[16px]"
          >
            <img
              src="@/assets/images/landing/close-menu.svg"
              alt="close-menu"
              width="20"
              height="20"
            />
          </button>
          <nav class="mobile-nav flex flex-col gap-[24px] items-start mt-5">
            <ul class="flex flex-col items-start gap-[12px] mobile-nav-list">
              <li>
                <a @click="isOpenMenu = false" href="#">Afzalliklari</a>
              </li>
              <li>
                <a @click="isOpenMenu = false" href="#">KPI nima?</a>
              </li>
              <li>
                <a @click="isOpenMenu = false" href="#">Bog‘lanish</a>
              </li>
              <li>
                <a @click="isOpenMenu = false" href="#">F.A.Q</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="flex flex-col gap-4 mt-4">
          <button
            class="sm:hidden cursor-pointer border border-[#e3e4e7] rounded-[12px] py-2 xl:py-3 px-4 xl:px-6 text-[#181818] text-[14px] leading-[150%]"
          >
            Ro'yxatdan o'tish
          </button>
          <button
            @click="handleTryClick"
            class="sm:hidden cursor-pointer border border-[#e3e4e7] bg-[#fff] rounded-[12px] py-2 xl:py-3 px-4 xl:px-6"
          >
            Foydalanish
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
@media (max-width: 640px) {
  .custom-container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 24px;
    padding-right: 24px;
  }
}

.mobile-menu {
  transform: translateX(-300px);
}

.mobile-menu-open {
  transform: translateX(0px);
}

.mobile-logo_text {
  color: #181818;
  text-shadow: 0.603px 0.603px 0px rgba(17, 17, 17, 0.25);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}
.mobile-nav-list li a {
  color: #181818;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
/* for white class*/
.logo,
.demo-button,
.links-list li a,
.use-button {
  transition: all 0.3s linear;
}
header.white .logo {
  color: #fff;
  text-shadow: 0.603px 0.603px 0px rgba(17, 17, 17, 0.25);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

header.white {
  border-bottom: 1px solid #597eff;
}

header.white .links-list li a {
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

header.white .demo-button {
  border-radius: 12px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.1);
  padding: 12px 24px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

header.white .use-button {
  border-radius: 12px;
  border: 1px solid #e3e4e7;
  background: #fff;
  padding: 12px 24px;

  color: #181818;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

/* for black class*/

header.black .logo {
  color: #181818;
  text-shadow: 0.603px 0.603px 0px rgba(17, 17, 17, 0.25);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

header.black {
  border-bottom: 1px solid #d5d6db;
}

header.black .links-list li a {
  color: #181818;
  text-align: center;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

header.black .demo-button {
  border-radius: 12px;
  border: 1px solid #3361ff;
  background: rgba(38, 87, 255, 0.05);
  padding: 12px 24px;
  color: #3361ff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

header.black .use-button {
  border-radius: 12px;
  background: #3361ff;
  padding: 12px 24px;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.user-avatar {
  color: #181818;
  border-radius: 12px;
  border-width: 1px;
  border-style: solid;
  padding: 0px 12px;
  transition: all 0.3s linear;
  padding: 12px 24px;
  width: 100%;
  height: 100%;
}
header.white .user-avatar {
  color: #fff;
  border-color: #fff;
}
</style>
